<div>
    <ng-container *ngIf="loading; else content">
        <div class="py-4 text-center">
            <app-loader></app-loader>
        </div>
    </ng-container>

    <ng-template #content>
        <ng-container *ngIf="offers.items.length === 0; else offerGrid">
            <div class="py-4 text-center">
                {{ 'No liked offers yet' | translate }}
            </div>
        </ng-container>

        <ng-template #offerGrid>
            <div class="row align-items-stretch">
                <div class="mb-4 col-12 col-lg-4" *ngFor="let offer of offers.items">
                    <app-offer-card class="h-100" [offer]="offer"></app-offer-card>
                </div>
            </div>
            <div class="mt-2" *ngIf="offers.total > offers.perPage">
                <app-pagination
                    [total]="offers.total"
                    [perPage]="offers.perPage"
                    [page]="offers.page"
                    (pageChanged)="pageChanged($event)"
                ></app-pagination>
            </div>
        </ng-template>
    </ng-template>
</div>
